import { render, staticRenderFns } from "./EditorNavMenuItemsV2.vue?vue&type=template&id=a71b4124&"
import script from "./EditorNavMenuItemsV2.vue?vue&type=script&lang=js&"
export * from "./EditorNavMenuItemsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports